// @flow
import React from "react";
import { connect } from "react-redux";
import Scroll from "react-scroll";
import Actions from "../../actions/Creators";
import moment from "moment";
import _ from "lodash";
import {
  Layout,
  ToggleButton,
  Loader,
  EmptyResults,
  Pagination,
  DatePicker,
  Button,
  Modal,
  Icon,
  SearchString
} from "../../components/common/";
import Print from "../../components/orders/print/Print";
import Helper from "../../helper/Helper";
import OrderTable from "../../components/orders/orderTable/OrderTable";
import Dropdown from "../../components/common/filterDropdown/Dropdown";
import I18n from "../../i18n/I18n";
import styles from "./Orders.scss";

class Home extends React.Component {
  state = {
    key: "",
    dir: "",
    limits: 20,
    page: 1,
    status: 1,
    is_fbn: 1,
    search: "",
    selectedOrders: [],
    actionBox: false,
    change: false,
    dialogOpen: false,
    requestOpen: false,
    view: "grid",
    selectedWarehouse: 1,
    id_warehouse: "",
    warehouseDropdown: "1",
    print: false,
    selectedDate: "",
    statusFilter: "0"
  };

  componentWillMount = () => {
    if (this.props.location && this.props.location.search) {
      this.getParams(this.props.location.search);
    }
    if (this.props.user && this.props.seller) {
      this.getWareHouses();

      this.getOrdersV2Data();
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.location &&
      prevProps.location &&
      this.props.location !== prevProps.location &&
      this.props.location.search
    ) {
      this.getParams(this.props.location.search);
    }

    if (
      this.state.print &&
      this.props.orders !== prevProps.orders &&
      this.props.orders.printOrders !== prevProps.orders.printOrders &&
      !this.props.isPrintLoading
    ) {
      this.printPreview();
    }

    if (
      this.props.orders.close !== prevProps.orders.close &&
      !this.props.isClosing
    ) {
      this.getOrdersV2Data();
    }

    if (
      (this.state.change && prevState.change !== this.state.change) ||
      (this.props.orders !== prevProps.orders &&
        this.props.orders.orders &&
        this.props.orders.orders.message &&
        this.props.orders.orders.message === "ok" &&
        !this.props.isLoading)
    ) {
      // this.getWareHouses();

      this.getOrdersV2Data();
    }
    if (
      this.state.itemDetails &&
      this.props.orders &&
      this.props.orders.singleOrder &&
      // this.props.orders.singleOrder !== prevProps.orders.singleOrder &&
      this.props.seller &&
      this.props.orders.singleOrder.orders
      // this.props.orders.singleOrder.orders !== prevProps.orders.singleOrder.orders
    ) {
      let statusNr = "";
      let is_fbn = 1;
      if (!_.isEmpty(this.props.orders.singleOrder.orders)) {
        const match = this.props.orders.singleOrder.orders[0];
        let tab = "";
        if (match) {
          tab = match.tab;
          statusNr = Helper.getStatusNr(tab, this.props.seller.is_fm_pickup);
          is_fbn = match.is_fbn + 1;
        }
      }
      this.setState({
        itemDetails: false,
        search: this.state.itemNr,
        status: statusNr || this.state.status,
        is_fbn: is_fbn,
        change: true
      });
    }
  }

  getParams = searchString => {
    const params = URLSearchParams ? new URLSearchParams(searchString) : "";
    const search = params && params.get("search");
    const itemNr = params && params.get("item_nr");
    const status = params && params.get("status");
    const newState = {};
    if (search) {
      newState.search = search;
    }
    if (status) {
      newState.status = Number(status);
    }
    if (itemNr) {
      this.getOrderDetails(itemNr);
      this.setPageUrl();
    }
    if (search || status) {
      newState.change = true;
      this.setPageUrl();
    }
    this.setState(newState);
  };

  getOrderDetails = item_nr => {
    let query = `item_nr=${item_nr}`;
    this.props.dispatch(Actions.getSingleOrder(query));
    const newState = {};
    newState.itemDetails = true;
    newState.itemNr = item_nr;
    this.setState(newState);
  };

  setPageUrl = () => {
    this.props.history.replace(`/${Helper.getLocale()}/orders`);
  };

  componentWillReceiveProps = nextProps => {
    if (
      this.props.match !== nextProps.match ||
      this.props.seller !== nextProps.seller
    ) {
      this.getWareHouses();

      this.getOrdersV2Data();
    }
  };

  getWareHouses = () => {
    this.props.dispatch(Actions.getWareHouses());
  };

  openDialog = () => {
    this.setState({
      dialogOpen: true
    });
  };

  openRequest = () => {
    this.setState({
      requestOpen: true
    });
  };

  closeDialog = () => {
    this.setState({
      dialogOpen: false
    });
  };

  closeRequest = () => {
    this.setState({
      requestOpen: false
    });
  };

  getOrdersV2Data = print => {
    const {
      key,
      dir,
      limits,
      page,
      status,
      is_fbn,
      search,
      selectedWarehouse,
      selectedDate,
      statusFilter
    } = this.state;

    const { warehouses } = this.props;

    const idWarehouseList = status !== 3 ? [0] : [];

    if (
      warehouses &&
      warehouses.warehouses &&
      !_.isEmpty(warehouses.warehouses)
    ) {
      for (let i = 0; i < warehouses.warehouses.length; i++) {
        if (
          this.state.is_fbn === 1 &&
          warehouses.warehouses[i].is_fbn === "0"
        ) {
          idWarehouseList.push(warehouses.warehouses[i].id_warehouse);
        } else if (
          this.state.is_fbn === 2 &&
          warehouses.warehouses[i].is_fbn === "1"
        ) {
          idWarehouseList.push(warehouses.warehouses[i].id_warehouse);
        }
      }
    }

    let is_readyforpickup = null;

    let id_warehouse =
      !this.state.warehouseDropdown || this.state.warehouseDropdown !== "1"
        ? this.state.warehouseDropdown
        : "";

    if (selectedWarehouse && !_.isEmpty(idWarehouseList)) {
      id_warehouse = idWarehouseList[selectedWarehouse - 1];
    }

    const fmIntegrated = this.props.seller && this.props.seller.is_fm_pickup;
    let statusText = Helper.getStatusText(status, fmIntegrated);
    let query = `limits=${print ? "1000" : limits}&page=${print ? "1" : page}`;
    query = statusText ? `${query}&status=${statusText}` : query;
    query =
      is_fbn && is_fbn !== "0"
        ? `${query}&is_fbn=${Number(is_fbn) - 1}`
        : query;
    query =
      is_readyforpickup || is_readyforpickup === 0
        ? `${query}&is_readyforpickup=${is_readyforpickup}`
        : query;
    query = key ? `${query}&sort=${key}` : query;
    query = key && dir ? `${query}&dir=${dir}` : query;
    query = search ? `${query}&search=${search}` : query;
    query = id_warehouse ? `${query}&id_warehouse=${id_warehouse}` : query;
    query = selectedDate ? `${query}&ordered_at=${selectedDate}` : query;
    query =
      statusFilter !== "0" && status === 2
        ? `${query}&status_filter=${Number(statusFilter)}`
        : query;
    this.props.dispatch(Actions.getOrdersV2(query, print));
    this.setState({
      change: false,
      id_warehouse: id_warehouse,
      selectedOrders: print ? this.state.selectedOrders : []
    });
    Scroll.animateScroll.scrollToTop({ delay: 0 });
  };

  onSearch = search => {
    const newState = {};
    newState.page = 1;
    newState.search = search;
    newState.change = true;
    this.setState(newState);
  };

  clearSearch = () => {
    const newState = {};
    newState.search = "";
    newState.change = true;
    this.setState(newState);
  };

  toggleStatus = status => {
    this.setState({
      status,
      page: 1,
      change: true,
      selectedWarehouse: status !== 3 ? this.state.selectedWarehouse : 1,
      warehouseDropdown: "1",
      selectedDate: ""
    });
  };

  toggleWarehouse = selectedWarehouse => {
    this.setState({
      selectedWarehouse,
      page: 1,
      change: true
    });
  };

  fbnToggle = fbn => {
    this.setState({
      is_fbn: fbn,
      page: 1,
      change: true
    });
  };

  onAcceptOrder = obj => {
    this.props.dispatch(Actions.postOrdersV2(obj));
    this.setState({
      change: true,
      selectedOrders: []
    });
  };

  onReadyToPickup = () => {
    if (!_.isEmpty(this.state.selectedOrders)) {
      const sel = this.state.selectedOrders;
      let s = new Set();
      let wh = new Set();

      const orders =
        this.props.orders &&
        this.props.orders.orders &&
        this.props.orders.orders.orders
          ? this.props.orders.orders.orders
          : [];
      for (let x = 0; x < sel.length; x++) {
        const match = orders.find(
          order => order && order.id_purchase_order_item === sel[x]
        );
        s.add(match.warehouse_code);
        if (this.props.warehouses && this.props.warehouses.warehouses) {
          const warehouses = this.props.warehouses.warehouses;
          const matchWhId = warehouses.find(
            warehouse => warehouse && warehouse.code === match.warehouse_code
          );
          if (matchWhId) {
            wh.add(matchWhId.id_warehouse);
          }
        }
      }
      const id_partner_warehouses = Array.from(s);
      const id_warehouses = Array.from(wh);
      const pickupOrders = {
        id_purchase_order_item: this.state.selectedOrders,
        id_partner_warehouses: id_partner_warehouses,
        id_warehouses: id_warehouses
      };

      if (this.state.status === 3) {
        delete pickupOrders.id_partner_warehouses;
      }

      this.props.dispatch(
        Actions.postPickupV2(pickupOrders, this.state.status === 3)
      );
      this.setState({
        change: true,
        selectedOrders: [],
        dialogOpen: false
      });
    }
  };

  sortColumn = (key, dir) => {
    const newState = {};
    newState.key = key;
    newState.dir = dir;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  onPageChange = page => {
    const newState = {};
    newState.page = page.selected + 1;
    newState.change = true;
    this.setState(newState);
  };

  perPage = e => {
    const newState = {};
    newState.limits = e;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  fbnChange = e => {
    const newState = {};
    newState.is_fbn = e;
    newState.selectedWarehouse = 1;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  viewChange = e => {
    const newState = {};
    newState.view = e;
    this.setState(newState);
  };

  warehouseChange = e => {
    const newState = {};
    newState.warehouseDropdown = e;
    newState.change = true;
    this.setState(newState);
  };

  filterChange = e => {
    const newState = {};
    newState.statusFilter = e;
    newState.page = 1;
    newState.change = true;
    this.setState(newState);
  };

  toggleCheckbox = id => {
    const selectedOrders = this.state.selectedOrders;
    if (selectedOrders) {
      if (selectedOrders.includes(id)) {
        _.remove(
          selectedOrders,
          id_purchase_order_item => id_purchase_order_item === id
        );
      } else {
        selectedOrders.push(id);
      }
    }
    const newState = {};
    newState.selectedOrders = selectedOrders;

    newState.actionBox = !_.isEmpty(selectedOrders);
    this.setState(newState);
  };

  selectAll = () => {
    const orders =
      this.props.orders &&
      this.props.orders.orders &&
      this.props.orders.orders.orders
        ? this.props.orders.orders.orders
        : [];
    let selectedOrders = this.state.selectedOrders;
    if (
      selectedOrders &&
      orders &&
      !_.isEmpty(orders) &&
      selectedOrders.length < orders.length
    ) {
      selectedOrders = [];
      for (let i = 0; i < orders.length; i++) {
        if (!orders[i].is_fbn) {
          selectedOrders.push(orders[i].id_purchase_order_item);
        }
      }
    } else {
      selectedOrders = [];
    }

    const newState = {};
    newState.selectedOrders = selectedOrders;
    newState.actionBox = !_.isEmpty(selectedOrders);
    this.setState(newState);
  };

  setRef = ref => {
    this.invoice = ref;
  };

  printOrders = () => {
    this.getOrdersV2Data(true);
    this.setState({
      print: true
    });
  };

  printPreview = () => {
    this.setState({
      print: false
    });
    this.invoice.onPrint();
  };

  acceptAll = () => {
    const { orders } = this.props;
    const idObj = [];
    if (
      orders &&
      orders.orders &&
      orders.orders.orders &&
      !_.isEmpty(orders.orders.orders)
    ) {
      for (let i = 0; i < orders.orders.orders.length; i++) {
        idObj.push(orders.orders.orders[i].id_purchase_order_item);
      }

      const obj = {
        id_purchase_order_item: idObj,
        is_accepted: true
      };
      this.onAcceptOrder(obj);
      this.closeDialog();
    }
  };

  selectedDate = date => {
    const formatted = moment(date).format();

    var newState = {};
    newState["selectedDate"] = formatted;
    this.setState(newState);
  };

  dateSubmit = () => {
    this.getOrdersV2Data();
  };

  clearDate = () => {
    this.setState({
      selectedDate: "",
      change: true
    });
  };

  openPickup = () => {
    // if (this.state.id_warehouse) {
    const warehouse = {
      id_partner_warehouse: this.state.id_warehouse
    };

    this.props.dispatch(Actions.openPickup(warehouse));
    this.closeRequest();
    // }
  };

  render() {
    const {
      seller,
      orders,
      warehouses,
      lang,
      isPrintLoading,
      isNoonUser
    } = this.props;
    let title = "orders.title";

    let warehouseOptions =
      this.state.status !== 3 ? [I18n.getText("orders.All")] : [];

    let warehousesDropdownOptions = [
      {
        value: "1",
        key: "1",
        label: I18n.getText("orders.All")
      }
    ];

    if (
      warehouses &&
      warehouses.warehouses &&
      !_.isEmpty(warehouses.warehouses)
    ) {
      for (let i = 0; i < warehouses.warehouses.length; i++) {
        const eachOption = {
          value: warehouses.warehouses[i].id_warehouse,
          key: warehouses.warehouses[i].id_warehouse,
          label: warehouses.warehouses[i].code
        };
        if (
          this.state.is_fbn === 1 &&
          warehouses.warehouses[i].is_fbn === "0"
        ) {
          warehouseOptions.push(
            warehouses.warehouses[i].code ||
              warehouses.warehouses[i].id_warehouse ||
              warehouses.warehouses[i].address
          );
          warehousesDropdownOptions.push(eachOption);
        } else if (
          this.state.is_fbn === 2 &&
          warehouses.warehouses[i].is_fbn === "1"
        ) {
          warehouseOptions.push(
            warehouses.warehouses[i].code ||
              warehouses.warehouses[i].id_warehouse ||
              warehouses.warehouses[i].address
          );
          warehousesDropdownOptions.push(eachOption);
        }
      }
    }

    const fulfilmentOptions =
      orders && orders.orders && orders.orders.orders
        ? [
            {
              value: 2,
              key: 2,
              label: I18n.getText("orders.by-noon")
            },
            {
              value: 1,
              key: 1,
              label: I18n.getText("orders.by-seller")
            }
          ]
        : [];

    const viewOptions = [
      {
        value: "grid",
        key: "grid",
        label: <Icon name="table" className={styles.viewIconTable} />
      },
      {
        value: "box",
        key: "box",
        label: <Icon name="list-view" className={styles.viewIcon} />
      }
    ];

    const statusOptions = [
      {
        value: "0",
        key: "0",
        label: I18n.getText("orders.All")
      },
      {
        value: "1",
        key: "1",
        label: I18n.getText("orders.accepted")
      },
      {
        value: "2",
        key: "2",
        label: I18n.getText("orders.rerequested")
      }
    ];

    const pageOptions =
      orders && orders.orders && orders.orders.orders
        ? [
            {
              value: 20,
              key: 20,
              label: I18n.getText("orders.20-per-page", {}, "20 Per Page")
            },
            {
              value: 40,
              key: 40,
              label: I18n.getText("orders.40-per-page", {}, "40 Per Page")
            },
            {
              value: 60,
              key: 60,
              label: I18n.getText("orders.60-per-page", {}, "60 Per Page")
            }
          ]
        : [];

    let modalSubmitLabel = I18n.getText("product.confirm-btn");
    let modalDialogTitle = I18n.getText("orders.ready-for-pickup");
    let confirmDeleteText = I18n.getText("orders.pickup-confirm", {
      count: this.state.selectedOrders.length
    });

    let modalSubmit = () => this.onReadyToPickup();

    switch (this.state.status) {
      case 1:
        modalSubmitLabel = I18n.getText("product.confirm-btn");
        modalDialogTitle = I18n.getText("orders.confirm-accept");
        modalSubmit = () => this.acceptAll();
        confirmDeleteText = I18n.getText("orders.accept-confirm", {
          count:
            this.props.orders &&
            this.props.orders.orders &&
            this.props.orders.orders.orders
              ? this.props.orders.orders.orders.length
              : 0
        });

        break;
      case 2:
        modalSubmitLabel = I18n.getText("product.confirm-btn");
        modalDialogTitle = I18n.getText("orders.ready-for-pickup");
        confirmDeleteText = I18n.getText("orders.pickup-confirm", {
          count: this.state.selectedOrders.length
        });
        break;
      case 3:
        modalSubmitLabel = I18n.getText("orders.remove-btn");
        modalDialogTitle = I18n.getText("orders.remove-items");
        confirmDeleteText = I18n.getText("orders.remove-items-confirm", {
          count: this.state.selectedOrders.length
        });

        break;
      default:
        modalSubmitLabel = I18n.getText("product.confirm-btn");
        modalDialogTitle = I18n.getText("orders.request-a-pickup");
    }

    const statusTabs = [
      <div className={styles.tabTitle}>
        {I18n.getText("orders.new")}
        {orders && orders.orderCount && orders.orderCount.counts ? (
          <div className={styles.count}>({orders.orderCount.counts.new})</div>
        ) : (
          ""
        )}
      </div>,
      <div className={styles.tabTitle}>
        {I18n.getText("orders.accepted")}
        {orders && orders.orderCount && orders.orderCount.counts ? (
          <div className={styles.count}>
            ({orders.orderCount.counts.accepted})
          </div>
        ) : (
          ""
        )}
      </div>,

      <div className={styles.tabTitle}>
        {I18n.getText("orders.completed")}
        {orders && orders.orderCount && orders.orderCount.counts ? (
          <div className={styles.count}>
            ({orders.orderCount.counts.completed})
          </div>
        ) : (
          ""
        )}
      </div>,
      <div className={styles.tabTitle}>
        {I18n.getText("orders.cancelled")}
        {orders && orders.orderCount && orders.orderCount.counts ? (
          <div className={styles.count}>
            ({orders.orderCount.counts.cancelled})
          </div>
        ) : (
          ""
        )}
      </div>,
      <div className={styles.tabTitle}>
        {I18n.getText("orders.returns")}
        {orders && orders.orderCount && orders.orderCount.counts ? (
          <div className={styles.count}>
            ({orders.orderCount.counts.returns})
          </div>
        ) : (
          ""
        )}
      </div>
    ];

    if (seller && seller.is_fm_pickup) {
      statusTabs.splice(
        2,
        0,
        <div className={styles.tabTitle}>
          {I18n.getText("orders.ready-for-pickup")}
          {orders && orders.orderCount && orders.orderCount.counts ? (
            <div className={styles.count}>
              ({orders.orderCount.counts.readyforpickup})
            </div>
          ) : (
            ""
          )}
        </div>,
        <div className={styles.tabTitle}>
          {I18n.getText("orders.processing")}
          {orders && orders.orderCount && orders.orderCount.counts ? (
            <div className={styles.count}>
              ({orders.orderCount.counts.picked})
            </div>
          ) : (
            ""
          )}
        </div>,
        <div className={styles.tabTitle}>
          {I18n.getText("orders.received")}
          {orders && orders.orderCount && orders.orderCount.counts ? (
            <div className={styles.count}>
              ({orders.orderCount.counts.received})
            </div>
          ) : (
            ""
          )}
        </div>
      );
    }

    const minimumPaidAtDate = moment().subtract(1, "year");
    const maxDate = moment();

    return (
      <Layout
        currentIndex={2}
        title={title}
        onSearch={this.onSearch}
        search={this.state.search}
        searchLabel={"orders.new-search-placeholder"}
      >
        {this.props.sessionIsLoading ? (
          <Loader />
        ) : (
          <div>
            {seller ? (
              seller.is_allow_stock_request && !isNoonUser ? (
                this.props.history.push(`/${Helper.getLocale()}/stock-request`)
              ) : (
                <div className={styles.orderCtr}>
                  <Print
                    setRef={this.setRef}
                    lang={lang}
                    selectedWarehouse={this.state.selectedWarehouse}
                    seller={seller}
                    selectedOrders={this.state.selectedOrders}
                    status={this.state.status}
                    printOrders={orders && orders.printOrders}
                    currencyCode={seller.currency_code}
                    warehouses={warehouses ? warehouses.warehouses : ""}
                  />

                  <div className={styles.toggleCtr}>
                    <ToggleButton
                      toggleBtn={this.fbnToggle}
                      toggleItems={[
                        I18n.getText("products.seller-b2b"),
                        I18n.getText("products.noon-now")
                      ]}
                      selected={this.state.is_fbn}
                    />
                  </div>
                  <div className={styles.toggleCtr}>
                    <ToggleButton
                      toggleBtn={this.toggleStatus}
                      fullWidth
                      tab
                      toggleItems={statusTabs}
                      selected={this.state.status}
                    />
                  </div>
                  {this.props.isLoading ||
                  this.props.sessionIsLoading ||
                  this.props.isClosing ? (
                    <div>
                      <Loader />
                    </div>
                  ) : (
                    <div>
                      <div className={styles.topCtr}>
                        <div className={styles.filterWrapper}>
                          <div
                            className={`${styles.eachFilter} ${styles.dateCtr}`}
                          >
                            <div className={styles.datePicker}>
                              <div className={styles.label}>
                                {I18n.getText("orders.order-date")}
                              </div>
                              {I18n.getComponent(
                                formattedValue => (
                                  <DatePicker
                                    // withPortal={!this.props.browser.greaterThan.tablet}
                                    placeholder={"YYYY-MM-DD"}
                                    initialDate={moment(
                                      this.state.selectedDate
                                    )}
                                    selectedDate={this.selectedDate}
                                    clearDate={!this.state.selectedDate}
                                    isOutsideRange={day =>
                                      day.isBefore(minimumPaidAtDate) ||
                                      day.isAfter(maxDate)
                                    }
                                  />
                                ),
                                "statement.start-date"
                              )}

                              <Button
                                variant="transparent"
                                className={styles.btn}
                                onClick={() => this.dateSubmit()}
                                disabled={!this.state.selectedDate}
                              >
                                {I18n.getText("statement.go-btn", {}, "Go")}
                              </Button>
                              <Button
                                variant="transparent"
                                onClick={this.clearDate}
                                className={styles.clear}
                                className={styles.btn}
                                disabled={!this.state.selectedDate}
                              >
                                {I18n.getText("statement.clear", {}, "Clear")}
                              </Button>
                            </div>
                          </div>

                          {(this.state.status === 2 ||
                            (this.state.status === 3 && seller.is_fm_pickup)) &&
                          orders &&
                          orders.orders &&
                          orders.orders.orders &&
                          !_.isEmpty(orders.orders.orders) ? (
                            <div className={styles.eachFilter}>
                              <Button
                                className={styles.printCtr}
                                onClick={() => this.printOrders()}
                              >
                                <Icon
                                  name="print"
                                  className={styles.printIcon}
                                />
                                {isPrintLoading ? (
                                  <div className={styles.loader} />
                                ) : (
                                  I18n.getText(
                                    !_.isEmpty(this.state.selectedOrders)
                                      ? "orders.print-selected"
                                      : "orders.print-all"
                                  )
                                )}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.status === 1 &&
                          orders &&
                          orders.orders &&
                          orders.orders.orders &&
                          seller.is_btn_active &&
                          !_.isEmpty(orders.orders.orders) ? (
                            <div className={styles.eachFilter}>
                              <Button
                                className={styles.printCtr}
                                variant="secondary"
                                onClick={() => this.openDialog()}
                              >
                                <Icon
                                  name="checkmark"
                                  className={styles.icon}
                                />
                                {this.props.isLoading ? (
                                  <div className={styles.loader} />
                                ) : (
                                  I18n.getText("orders.accept-all")
                                )}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          {(this.state.status === 2 ||
                            this.state.status === 3) &&
                          !_.isEmpty(this.state.selectedOrders) ? (
                            <div className={styles.eachFilter}>
                              <Button
                                variant={
                                  this.state.status === 3
                                    ? "warning"
                                    : "secondary"
                                }
                                className={styles.actionBtn}
                                onClick={() => this.openDialog()}
                              >
                                {this.state.status === 3
                                  ? I18n.getText("orders.remove-items")
                                  : I18n.getText("orders.ready-for-pickup")}
                              </Button>
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            className={`${styles.eachFilter} ${
                              styles.viewFilter
                            }`}
                          >
                            <Dropdown
                              onChange={this.viewChange}
                              selected={this.state.view}
                              options={viewOptions}
                              label={I18n.getText("filter.view")}
                            />
                          </div>
                          {this.state.status !== 2 && false ? (
                            <div className={styles.eachFilter}>
                              <Dropdown
                                onChange={this.warehouseChange}
                                selected={this.state.warehouseDropdown}
                                options={warehousesDropdownOptions}
                                label={I18n.getText("orders.warehouse")}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.status === 2 ? (
                            <div className={styles.eachFilter}>
                              <Dropdown
                                onChange={this.filterChange}
                                selected={this.state.statusFilter}
                                options={statusOptions}
                                label={I18n.getText("orders.filter-by")}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          <div className={styles.eachFilter}>
                            <Dropdown
                              onChange={this.perPage}
                              selected={this.state.limits}
                              options={pageOptions}
                              label={I18n.getText(
                                "orders.display",
                                {},
                                "Display"
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      {this.state.search ? (
                        <SearchString
                          search={this.state.search}
                          clearSearch={this.clearSearch}
                        />
                      ) : (
                        ""
                      )}

                      <div>
                        <ToggleButton
                          toggleBtn={this.toggleWarehouse}
                          tab
                          toggleItems={warehouseOptions}
                          selected={this.state.selectedWarehouse}
                          btns={
                            seller.is_fm_pickup &&
                            this.state.status === 3 &&
                            orders &&
                            false &&
                            orders.orders &&
                            orders.orders.orders &&
                            !_.isEmpty(orders.orders.orders) && (
                              <Button
                                variant="secondary"
                                onClick={() => this.openRequest()}
                              >
                                {I18n.getText("orders.request-pickup", {
                                  warehouse:
                                    warehouseOptions[
                                      this.state.selectedWarehouse - 1
                                    ]
                                })}
                              </Button>
                            )
                          }
                        />
                      </div>

                      {orders &&
                      orders.orders &&
                      orders.orders.orders &&
                      !_.isEmpty(orders.orders.orders) ? (
                        <OrderTable
                          orderStatus={this.state.status}
                          lang={lang}
                          sellerCountry={seller.country_code}
                          fmIntegrated={seller.is_fm_pickup}
                          data={orders.orders.orders}
                          toggleCheckbox={this.toggleCheckbox}
                          selectAll={this.selectAll}
                          view={this.state.view}
                          searchString={this.state.search}
                          allSelected={
                            this.state.selectedOrders.length ===
                            orders.orders.orders.length
                          }
                          browser={this.props.browser}
                          indeterminate={
                            this.state.selectedOrders &&
                            !_.isEmpty(this.state.selectedOrders) &&
                            this.state.selectedOrders.length !==
                              orders.orders.orders.length
                          }
                          onAcceptOrder={this.onAcceptOrder}
                          currencyCode={seller.currency_code}
                          selectedOrders={this.state.selectedOrders}
                        />
                      ) : (
                        <EmptyResults
                          type="orders"
                          fmIntegrated={seller.is_fm_pickup}
                          status={this.state.status}
                        />
                      )}
                      {orders &&
                      orders.orders &&
                      orders.orders.no_of_pages &&
                      orders.orders.no_of_pages > 1 ? (
                        <div className={styles.paginationWrapper}>
                          <Pagination
                            pageCount={Number(orders.orders.no_of_pages)}
                            currentPage={this.state.page}
                            onPageChange={this.onPageChange}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>
              )
            ) : (
              <EmptyResults />
            )}
            <Modal
              contentLabel={"deleteConfirm"}
              isOpen={this.state.dialogOpen}
              closeModal={() => this.closeDialog()}
              dialogBox
              onSubmit={modalSubmit}
              cancelBtnLabel={I18n.getText("product.cancel-btn")}
              warning={this.state.status === 3}
              submitBtnLabel={modalSubmitLabel}
              dialogTitle={modalDialogTitle}
            >
              <div className={styles.confirmDelete}>{confirmDeleteText}</div>
            </Modal>
            <Modal
              contentLabel={"requestPickup"}
              isOpen={this.state.requestOpen}
              closeModal={() => this.closeRequest()}
              dialogBox
              onSubmit={() => this.openPickup()}
              cancelBtnLabel={I18n.getText("product.cancel-btn")}
              submitBtnLabel={I18n.getText("product.confirm-btn")}
              dialogTitle={I18n.getText("orders.request-a-pickup")}
            >
              <div className={styles.confirmDelete}>
                {I18n.getText("orders.pickup-request-confirm", {
                  count:
                    orders && orders.orders && orders.orders.orders
                      ? orders.orders.orders.length
                      : 0,
                  warehouse: warehouseOptions[this.state.selectedWarehouse - 1]
                })}
              </div>
            </Modal>
          </div>
        )}
      </Layout>
    );
  }
}
const mapStateToProps = state => ({
  sessionIsLoading: state.session.isLoading,
  session: state.session,
  lang: state.locale.lang,
  user: state.session.user,
  seller: state.session.seller,
  isNoonUser: state.session.isNoonUser,
  orders: state.orders,
  isLoading: state.orders.isLoading,
  isPrintLoading: state.orders.isPrintLoading,
  isCountLoading: state.orders.isCountLoading,
  browser: state.browser,
  warehouses: state.session.wareHouses
});

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/containers/ordersV2/Orders.js